/**
 * ============================================================================
 * APPLICATION ROUTER AGGREGATOR
 * ============================================================================
 * Purpose:
 *   Combines Master Administration and User/Tenant Workspace routes into
 *   a unified, authenticated navigation tree.
 * ============================================================================
 */

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Layout from "../components/layout/Layout";
import Home from "../master/pages/dashboard/Home";
import SignIn from "../master/pages/auth/SignIn";
import LinkExpired from "../pages/public/LinkExpired";
import LinkNotFound from "../pages/public/LinkNotFound";
import RedirectBridge from "../pages/public/RedirectBridge";

import masterRoutes from "./masterRoutes";
import userRoutes from "./userRoutes";

import ProtectedRoute from "./ProtectedRoute";
import { getCurrentUser } from "../core/utils/auth";
import { STORAGE_KEYS } from "../core/config/constants";

// PublicRoute redirect to / if already logged in
function PublicRoute({ children }) {
  const token = localStorage.getItem(STORAGE_KEYS.TOKEN || "token");
  const user = getCurrentUser();
  if (token && user) {
    return <Navigate to="/" replace />;
  }
  return children;
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/signin"
        element={
          <PublicRoute>
            <SignIn />
          </PublicRoute>
        }
      />

      {/* Public Tiny URL Status Pages & Redirection Bridge */}
      <Route path="/link-expired" element={<LinkExpired />} />
      <Route path="/link-not-found" element={<LinkNotFound />} />
      <Route path="/r/:code" element={<RedirectBridge />} />
      <Route path="/r/:code/*" element={<RedirectBridge />} />
      <Route path="/:code" element={<RedirectBridge />} />
      <Route path="/:code/*" element={<RedirectBridge />} />

      {/* Main Platform Shell Layout (Strictly Protected) */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Home />} />

        {/* Master Admin Routes */}
        {masterRoutes}

        {/* User / Tenant Workspace Routes */}
        {userRoutes}

        {/* Fallback to Dashboard */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>

      <Route path="*" element={<Navigate to="/signin" replace />} />
    </Routes>
  );
}
